export const InputClass =
  "focus:outline focus:outline-1 focus:outline-gray-400 outline outline-1 outline-gray-400 p-1 rounded-4";

export const InputClassForLoginAndRegister =
  "focus:outline focus:outline-1 focus:outline-red-400 outline outline-1 outline-gray-400 rounded-4";
